import { GeneralTable } from "@/shared/components/ui";
import { useCheckPermissionsArray, useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import { Grid, IconButton, Tooltip } from "@mui/material";
import {
  EstadoProspectoEnum,
  ROUTER_PATHS,
  TABLE_CONSTANTS
} from "@/shared";
import { ISolicitudEvento } from "@/shared/interfaces";
import { Edit } from "@mui/icons-material";
import { useTableColumnsMarketing } from "@/shared/hooks/useTableColumnsMarketing";
import { useNavigate } from "react-router-dom";
import { PermissionsEnum } from "@/auth/interfaces";
import { useFetchSolicitudEvento } from "@/shared/actions/erp/marketing/solicitudEvento.action";

interface TableSolucionSolicitudEventoProps {
  showCustomActionBtnSpace?: boolean
  enableEditing?: boolean
  estado_prospecto?: EstadoProspectoEnum
}


export default function TableSolucionSolicitudEvento({
  showCustomActionBtnSpace = true,
  enableEditing = true,

}: TableSolucionSolicitudEventoProps) {

  useCheckPermissionsArray([
    PermissionsEnum.api_view_solicitudevento,
    PermissionsEnum.api_change_solicitudevento
  ]);

  const navigate = useNavigate()

  ///* form
  // const form = useForm<FormEditProspecto>({
  //   resolver: yupResolver(newEditarProspecteoSchema),
  // });

  // const {
  //   reset,
  //   control,
  //   formState: { errors },
  // } = form;


  // const {
  //   reset: resetMotivoRechazar,
  // } = formRechazo;

  ///* Hooks
  const {
    columnsSolicitudEvento
  } = useTableColumnsMarketing();

  const {
    pagination,

    setPagination,
  } = useTableFilter();

  const { pageIndex } = pagination;

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  // const {
  //   data: SolicitudEventoData,
  //   isLoading,
  //   isRefetching
  // } = useFetchGetfactibilidadCorporativos({
  //   page: pageIndex + 1,
  //   ...filterObject,
  //   filterByState: false,
  //   solicitud_evento_isnull: false 
  // })

  const { isLoading, data: SolicitudEventoData, isRefetching } =
      useFetchSolicitudEvento({
        page: pageIndex + 1,
        ...filterObject,
        filterByState: false
      });






  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>

        </Grid>

        <Grid item xs={12}>
          <GeneralTable<ISolicitudEvento>
            columns={columnsSolicitudEvento}
            data={SolicitudEventoData?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            ///* search
            enableGlobalFilter={false}
            enableSorting={false}
            // onGlobalFilterChange={setGlobalFilter}
            ///* pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={SolicitudEventoData?.data?.count}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}

            // crud
            canEdit={false}
            enableEditing={enableEditing}
            showCustomActionBtnSpace={showCustomActionBtnSpace}
            actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_MEDIUM}

            customActionBtnSpace={(value) => {
              return (
                <Grid container>
                  <Grid item >
                    {
                      value?.factibilidad_corporativa_data
                      &&value?.factibilidad_corporativa_data?.preaprobado_inventario?
                        <Tooltip title={'Revisar Factibilidad'} placement="top">
                          <IconButton
                            onClick={() => {
                              navigate(ROUTER_PATHS.marketing.solucionSolicitudesCanjeEventoNav + "/" + value?.factibilidad_corporativa_data?.id_factibilidad_coorporativa)
                            }
                            }
                          >
                            <Edit />
                          </IconButton>
                        </Tooltip>
                        : null
                    }
                  </Grid>
                </Grid>
              )
            }
            }
          />
        </Grid>
      </Grid>


    </>

  );



}